<div class="modal-header">
  <h4 class="modal-title" data-cy="verifyAccountTitle">Please verify your account information</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body m-1">
  <form>
    <formly-form [form]="form" [fields]="fields" [model]="model()" data-cy="modalForm" />
  </form>
</div>
<div class="modal-footer">
  <chitin-button label="Cancel" (clicked)="modal.dismiss()" [outline]="true" />
  <chitin-button label="Save changes" (clicked)="confirm()" [isLoading]="isSaving()" data-cy="submitBtn" />
</div>
